import { createDocumentPagePdfEngine, isSupportedImageFile } from '../shared/documentPagePdfEngine';

const engine = createDocumentPagePdfEngine(88, 125);

export { isSupportedImageFile };
export const resolveOrientation = engine.resolveOrientation;
export const computeCardLayout = engine.computeCardLayout;
export const computePassportCopyPairRects = engine.computeCopyPairRects;
export const loadImageFromFile = engine.loadImageFromFile;
export const renderPassportPreviewCanvas = engine.renderPreviewCanvas;
export const createPassportPdf = engine.createPdf;
export const createPassportPageImage = engine.createPageImage;
